import React, { Component } from 'react'
import { StyledContent } from '../../styles/mixins'
import { StyledCard } from './style'
import { Row, Col, Spin, Card } from 'antd';
import imgLogo from '../../static/images/imgLogo.png';
import { Auth } from '../../services/auth'
const { Meta } = Card;

class SuccessPage extends Component {
  
  state = {
    auth: new Auth()
  }
  
  onLogin = () => {
    this.state.auth.showLock();
  }
  
  render() {
    
    return (
      <StyledContent>
        <StyledCard bordered={false}>
          <Row gutter={16}>
            <Col sm={24} xs={24}>
              <center>
                <img src={imgLogo} alt="logo" />
                <div className="mtb-50"><h1>Welcome to OptionsEDU</h1></div>
              </center>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col sm={24} xs={24}>
             <center>
                <div style={{width: 200, height: 60}}>
                  <Card onClick={this.onLogin} >Login</Card>
                </div>
             </center>
            </Col>
          </Row>
        </StyledCard>
      </StyledContent>
    )
  }
}

export default SuccessPage



// WEBPACK FOOTER //
// ./src/components/Home/SuccessPage.js